import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default custom-card-height" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "card-body p-2" }
const _hoisted_10 = { class: "card-body-grid" }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "btn-group actions-row",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  class: "modal fade",
  id: "userModal",
  role: "dialog"
}
const _hoisted_18 = { class: "modal-dialog modal-lg" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = { class: "modal-title" }
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = ["readonly"]
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "position-relative" }
const _hoisted_35 = ["type"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = {
  key: 0,
  class: "row"
}
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { style: {"max-height":"calc(100vh - 390px)","overflow":"auto"} }
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_SubscriptionCommonComponent = _resolveComponent("SubscriptionCommonComponent")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_ejs_dropdownlist = _resolveComponent("ejs-dropdownlist")!
  const _component_CustomTreeView = _resolveComponent("CustomTreeView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isHost())
                ? (_openBlock(), _createBlock(_component_SubscriptionCommonComponent, {
                    key: 0,
                    onOnSubscription: _ctx.onSubscriptionChange
                  }, null, 8, ["onOnSubscription"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open(true)))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t("addNew")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ejs_grid, {
              ref: "gridUser",
              dataSource: _ctx.data,
              allowPaging: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 38,
              allowSorting: true,
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    (_ctx.isHost())
                      ? (_openBlock(), _createBlock(_component_e_column, {
                          key: 0,
                          headerText: _ctx.$t('organization') + ' ' + _ctx.$t('name'),
                          field: "organizationName"
                        }, null, 8, ["headerText"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('user') + ' ' + _ctx.$t('name'),
                      field: "dbUserId"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('password'),
                      field: "dummyPassword",
                      template: 'passwordColumnTemplate'
                    }, {
                      passwordColumnTemplate: _withCtx(({ data }) => [
                        (
                    data.dbUserPassword &&
                    data.dbUserPassword.length > 0
                  )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "copy-icon",
                              href: "#",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.$t('copy')
                            }, [
                              _createElementVNode("i", {
                                class: "fas fa-copy",
                                onClick: ($event: any) => (_ctx.copyToClipboard(data.dbUserPassword))
                              }, null, 8, _hoisted_12)
                            ], 8, _hoisted_11))
                          : _createCommentVNode("", true),
                        (data.dummyPassword)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(data.dummyPassword), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('allowedIPs'),
                      field: "allowedIPs"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('User Type'),
                      field: "userType"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      width: "75",
                      textAlign: "Center",
                      template: 'actionTemplate'
                    }, {
                      actionTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-edit",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.commandClick('Edit', data))
                          }, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("i", {
                              class: "e-edit e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_15),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-delete",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.commandClick('Delete', data))
                          }, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("i", {
                              class: "e-delete e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_16)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t("database") + " " + _ctx.$t("user")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onUpsert && _ctx.onUpsert(...args)))
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("customer")) + " ", 1),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_ejs_dropdownlist, {
                      id: "customerdd",
                      ref: "customerdd",
                      modelValue: _ctx.form.subscriptionId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.subscriptionId) = $event)),
                      dataSource: _ctx.listSubscription,
                      fields: _ctx.fieldsSubscription,
                      placeholder: _ctx.$t('msgSelectCustomer'),
                      onSelect: _ctx.onSelectCustomer,
                      enabled: !_ctx.isUpdate
                    }, null, 8, ["modelValue", "dataSource", "fields", "placeholder", "onSelect", "enabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("user") + " " + _ctx.$t("type")) + " ", 1),
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_ejs_dropdownlist, {
                      id: "dbUserdd",
                      ref: "dbUserdd",
                      modelValue: _ctx.form.userType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.userType) = $event)),
                      dataSource: _ctx.listUserType,
                      fields: _ctx.fieldsUserType,
                      placeholder: _ctx.$t('msgSelectUserType'),
                      onSelect: _ctx.onSelectCustomer,
                      required: ""
                    }, null, 8, ["modelValue", "dataSource", "fields", "placeholder", "onSelect"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("username")) + " ", 1),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.dbUserId) = $event)),
                      required: "",
                      readonly: _ctx.isUpdate
                    }, null, 8, _hoisted_31), [
                      [_vModelText, _ctx.form.dbUserId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("password")) + " ", 1),
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: _ctx.showPassword ? 'text' : 'password',
                        class: "form-control input-sm",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.dbUserPassword) = $event)),
                        required: "",
                        style: {"padding-right":"2.2rem !important"}
                      }, null, 8, _hoisted_35), [
                        [_vModelDynamic, _ctx.form.dbUserPassword]
                      ]),
                      _createElementVNode("span", {
                        class: "password-toggle-icon",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(_ctx.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye')
                        }, null, 2)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("allowedIPs")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.allowedIPs) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.allowedIPs]
                    ])
                  ])
                ])
              ]),
              (_ctx.form.userType == 'StagingEditor')
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("table permission")) + " ", 1),
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_CustomTreeView, {
                            dataSource: _ctx.treeViewData,
                            fields: { id: 'id', pid: 'pid', text: 'text', hasChildren: 'hasChild' },
                            modelValue: _ctx.scopeTreeSelectedNodes,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scopeTreeSelectedNodes) = $event))
                          }, null, 8, ["dataSource", "modelValue"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-close",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.close()))
              }, [
                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("close")), 1)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-sm btn-outline-info-reverse",
                disabled: _ctx.form.subscriptionId == '' || _ctx.form.userType == ''
              }, [
                _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.isUpdate ? _ctx.$t("update") : _ctx.$t("save")), 1)
              ], 8, _hoisted_44)
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}